import { SWRConfiguration } from 'swr'

import { V1Project } from '@infura/packages.uks'

import { useUKSProjects } from 'hooks/useUKSProjects'

export type AllUKSProjects = { ethereum: Array<V1Project>; ipfs: [] }

export function useAllProjects(config?: SWRConfiguration) {
  const swr = useUKSProjects(config)

  // @ts-expect-error enabled to support strictNullChecks - Please fix this if you can!
  const projects = swr.data ? { ethereum: Object.values(swr.data.result.projects), ipfs: [] } : undefined

  return { ...swr, projects: projects as AllUKSProjects }
}
